<template>
  <div class="pages">
    <navTop></navTop>
    <!-- 标题 -->
    <div class="title">
      <span>{{ title }}</span>
    </div>
    <!--  @click="goDetails(item.serveId)" -->
    <div class="lt-bottom">
      <div class="lt-bottom-item" v-for="(item, index) in jysList" :key="index"
        @click="goOrder(item)">
        <img style="object-fit: cover;" v-if="item.icon" :src="item.icon" />
        <img style="object-fit: cover;" v-else src="../../assets/logo.png" />
        <p class="jys" v-if="item.level == 0">Junior</p>
        <p class="jys" v-if="item.level == 1">Intermediate</p>
        <p class="jys" v-if="item.level == 2">Senior</p>
        <p class="jys" v-if="item.level == 3">Expert</p>
        <p class="name" v-if="item.name">
          <!-- {{ item.name.substr(0, 1) }} Inspector -->
          <!-- {{ item.name }} -->
          {{ item.n1||'' }}***
        </p>
        <!-- <p class="order">{{ item.counts || 0 }}</p> -->
        <p class="order">{{ item.country }}</p>
        <p class="age">{{ item.workYear }} Year</p>
        <p class="star">{{ item.score }} Score</p>
        <!-- <p class="money">{{ parseInt(item.price) || 0 }}</p> -->
        <p class="money" style="left: 190px">{{ item.mail }}</p>
      </div>
    </div>
    <!-- 底部 -->
    <navFooter></navFooter>
  </div>
</template>

<script>
import navTop from "../../components/navTop.vue";
import navFooter from "../../components/navFooter.vue";
export default {
  data () {
    return {
      title: "",
      id: "1",
      jysList: [],
      calendarList: [], //已选日期
    };
  },
  components: {
    navTop,
    navFooter,
  },
  methods: {
    // 检验师、服务详情
    goDetails (id) {
      let { href } = this.$router.resolve({
        path: "/detail",
        query: { id: id },
      });
      window.open(href, "_blank");
    },
    async listByServe () {
      let xhr = await this.$api.listByServe({
        serveId: this.id,
        nowPage: 1,
        pageCount: 100000,
      });
      if (xhr.result == "0") {
        this.jysList = xhr.data.list;
      }
    },
    // 立即下单
    goOrder (item) {
      console.log("lijia");
      if (item.serveType == 4) {
        let obj = {
          docId: item.id,
          serveId: this.id,
          serveTitle: item.serveTitle,
          name: item.name,
          price: item.price,
          serveType: item.serveType,
          counts: item.counts || 0,
          workYear: item.workYear,
          workDate: JSON.stringify(this.calendarList),
          workArea: item.workArea,
          dateWorkArg: JSON.stringify(item.dateWorkArg || []),
          dateRestArg: JSON.stringify(item.dateRestArg || []),
          servePic: item.pic,
          appraiseStar: item.score,
        };
        this.$router.push({
          path: "/insuranceOrder",
          query: { obj: JSON.stringify(obj) },
        });
      } else {
        let obj = {
          docId: item.id,
          serveId: this.id,
          serveTitle: item.serveTitle,
          name: item.name,
          price: item.price,
          serveType: item.serveType,
          counts: item.counts || 0,
          workYear: item.workYear,
          workDate: JSON.stringify(this.calendarList),
          workArea: item.workArea,
          dateWorkArg: JSON.stringify(item.dateWorkArg || []),
          dateRestArg: JSON.stringify(item.dateRestArg || []),
          servePic: item.pic,
          appraiseStar: item.score,
        };
        this.$router.push({
          path: "/placeOrder",
          query: { obj: JSON.stringify(obj) },
        });
      }
    },
  },

  created () {
    console.log(this.$route.query);
    if (this.$route.query.name) {
      this.title = this.$route.query.name;
      this.id = this.$route.query.id;
      this.listByServe();
    }
  },
};
</script>

<style lang="scss" scoped>
.lt-bottom {
  padding: 60px 40px 0;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  .lt-bottom-item {
    width: 425px;
    height: 181px;
    background-image: url("../../assets/index-item.png");
    background-size: 100% 100%;
    margin-bottom: 54px;
    margin-right: 14px;
    position: relative;
    img {
      width: 110px;
      height: 110px;
      background: #b7f0ff;
      border-radius: 50%;
      position: absolute;
      top: 35px;
      left: 38px;
    }
    .jys {
      width: 120px;
      min-height: 21px;
      word-break: break-all;
      background: #0a3063;
      border: 1px solid #227ea1;
      border-radius: 11px;
      font-size: 14px;
      word-break: break-all;
      font-weight: bold;
      color: #ffffff;
      text-align: center;
      line-height: 21px;
      position: absolute;
      bottom: 34px;
      left: 30px;
    }
    .name {
      font-size: 14px;
      font-weight: bold;
      color: #83c3d1;
      position: absolute;
      top: 10px;
      left: 220px;
    }
    .order {
      font-size: 14px;
      font-weight: bold;
      color: #83c3d1;
      position: absolute;
      top: 46px;
      left: 220px;
    }
    .age {
      font-size: 14px;
      font-weight: bold;
      color: #83c3d1;
      position: absolute;
      top: 79px;
      left: 226px;
    }
    .star {
      font-size: 14px;
      font-weight: bold;
      color: #83c3d1;
      position: absolute;
      top: 114px;
      left: 223px;
    }
    .money {
      font-size: 14px;
      font-weight: bold;
      color: #83c3d1;
      position: absolute;
      top: 144px;
      left: 220px;
    }
  }
  .lt-bottom-item:nth-child(4n) {
    margin-right: 0;
  }
}
.title {
  margin-top: 50px;
  width: 100%;
  height: 131px;
  background-image: url(../../assets/details-title.png);
  background-size: 100% 100%;
  position: relative;
  span {
    margin: 0 auto;
    width: 1504px;
    height: 87px;
    display: block;
    text-align: center;
    font-size: 40px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #00fcff;
    line-height: 87px;
    padding-right: 70px;
    box-sizing: border-box;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  img {
    width: 48px;
    height: 42px;
    display: block;
    position: absolute;
    top: 22px;
    right: 200px;
  }
}
</style>